module.exports = {
    tag: 'focus',
    quality: 0.4,
    mentalResil: 2,
};